var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 4C7.75 2.48122 8.98122 1.25 10.5 1.25H13C14.5188 1.25 15.75 2.48122 15.75 4H20C21.1046 4 22 4.89543 22 6V12C22 13.1046 21.1046 14 20 14H12.75V12C12.75 11.5858 12.4142 11.25 12 11.25C11.5858 11.25 11.25 11.5858 11.25 12V14H4C2.89543 14 2 13.1046 2 12V6C2 4.89543 2.89543 4 4 4H7.75ZM9.25 4H14.25C14.25 3.30964 13.6904 2.75 13 2.75H10.5C9.80964 2.75 9.25 3.30964 9.25 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49719 15.4642L3.8579 20.1534C3.93806 21.1954 4.80694 22 5.85201 22H18.1479C19.193 22 20.0618 21.1954 20.142 20.1534L20.5027 15.4642C20.3385 15.4878 20.1707 15.5 19.9999 15.5H3.99995C3.82923 15.5 3.66137 15.4878 3.49719 15.4642Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseAlt);
export default __webpack_public_path__ + "static/media/briefcase-alt.f3a37bb508900c503769252bc591bfac.svg";
export { ForwardRef as ReactComponent };